const PhoneIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M13.1421 12.2053L11.6146 14.1153C9.24769 12.7246 7.27531 10.7523 5.88464 8.38531L7.79464 6.85781C8.01854 6.67864 8.17678 6.43034 8.24462 6.15172C8.31247 5.8731 8.2861 5.57986 8.16964 5.31781L6.42839 1.39656C6.30352 1.11557 6.08291 0.888052 5.8059 0.754582C5.52888 0.621112 5.21347 0.59036 4.91589 0.66781L1.60089 1.52656C1.29169 1.60763 1.0229 1.79916 0.845323 2.06495C0.667746 2.33074 0.593686 2.65237 0.637142 2.96906C1.21876 7.11123 3.13312 10.9515 6.09081 13.9091C9.0485 16.8668 12.8887 18.7812 17.0309 19.3628C17.3475 19.4065 17.669 19.3325 17.9347 19.1549C18.2003 18.9772 18.3916 18.7083 18.4721 18.3991L19.3321 15.0853C19.4096 14.7877 19.3788 14.4723 19.2454 14.1953C19.1119 13.9183 18.8844 13.6977 18.6034 13.5728L14.6821 11.8316C14.4201 11.7154 14.1271 11.6891 13.8486 11.7567C13.5701 11.8242 13.3217 11.982 13.1421 12.2053Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PhoneIcon;
